import React from 'react';

const AppIcon = ({ icon, className, ...props }) => {
	return <span className={`app-icon icon-${icon} ${className ? className : ''} `} {...props} />;
};

export default AppIcon;
